import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "casino_all" };
import { computed, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { useCasinoLiveStore } from "@/stores/casino-live";
import CasinoLiveComponent from "@/components/CasinoLive/CasinoLiveComponent.vue";
// Setup reactive variables and methods
export default /*@__PURE__*/ _defineComponent({
    __name: 'CasinoLivePage',
    setup(__props) {
        const casinoLiveStore = useCasinoLiveStore();
        const route = useRoute();
        const games = computed(() => casinoLiveStore.games);
        const liveGameCategories = computed(() => casinoLiveStore.liveGameCategories);
        const defaultObject = {
            id: 1,
            name: '',
            logoURL: '',
            providerID: '',
            iconURL: '',
            bannerURL: '',
            key: 'all'
        };
        const selectedLiveCategory = ref(defaultObject);
        const isLoading = ref(false); // Track the loading state
        const loadMoreGames = async () => {
            isLoading.value = true; // Set loading to true when fetching games
            // setTimeout(async () => {
            const categoryId = selectedLiveCategory.value?.providerID;
            const key = selectedLiveCategory.value?.key;
            await casinoLiveStore.fetchGames(casinoLiveStore.page + 1, categoryId, key);
            casinoLiveStore.incrementPage();
            isLoading.value = false; // Set loading to false once the fetch is complete
            // }, 2000);
        };
        const initializeData = async () => {
            casinoLiveStore.clearGames(); // Assuming `clearGames` is a method to empty the `games` array
            isLoading.value = true;
            // Fetch initial game categories if not already fetched
            if (casinoLiveStore?.liveGameCategories?.length === 0) {
                await casinoLiveStore.fetchGameCategories();
            }
            // Get the current route parameter (href)
            const href = route.params.id || "all"; // Default to "all" if no param is provided
            // Find matching category or reset to "all"
            const category = casinoLiveStore?.liveGameCategories?.length > 0 && casinoLiveStore.liveGameCategories.find((category) => category.key === href);
            selectedLiveCategory.value = category || defaultObject;
            // Delay for 2 seconds, then fetch the games
            // setTimeout(async () => {
            const categoryId = selectedLiveCategory.value.providerID;
            const key = selectedLiveCategory.value?.key;
            await casinoLiveStore.fetchGames(1, categoryId, '');
            await casinoLiveStore.fetchGames(2, categoryId, '');
            await casinoLiveStore.fetchGames(3, categoryId, '');
            isLoading.value = false; // Set loading to false after fetching data
            // }, 2000);
        };
        // Watch for route changes to reinitialize data
        watch(() => route.params.id, initializeData);
        // Call initialization immediately
        initializeData();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(CasinoLiveComponent, {
                    games: games.value,
                    liveGameCategories: liveGameCategories.value,
                    selectedLiveCategory: selectedLiveCategory.value,
                    isLoading: isLoading.value,
                    onViewGames: loadMoreGames
                }, null, 8, ["games", "liveGameCategories", "selectedLiveCategory", "isLoading"])
            ]));
        };
    }
});
